import BaseApiService from './BaseApiService';

class CartApiService extends BaseApiService {
  addToCart = async (courseId) => {
    const response = await this.getAxiosInstance().post('/cart/add', { courseId });
    return response.data;
  };

  getCart = async () => {
    const response = await this.getAxiosInstance().get('/cart');
    return response.data;
  };

  checkout = async (selectedCourseIds) => {
    const response = await this.getAxiosInstance().post('/order/checkout', { selectedCourseIds });
    return response.data;
  };

  removeFromCart = async (courseId) => {
    const response = await this.getAxiosInstance().delete('/cart/remove', { data: { courseId } });
    return response.data;
  };

  getCartCount = async () => {
    const response = await this.getAxiosInstance().get('/cart/count');
    return response.data;
  };
}

export default new CartApiService();
